import React from 'react';
import Icons from 'assets/images/Icons';

const DownloadPayouts = () => (
  <button className='primary big'><Icons name='Download' /></button>
);

export default DownloadPayouts;